import {MdShare} from 'react-icons/md';

type Props = {className?: string; path?: string};

export const ShareButton: React.FC<Props> = ({className, path}) => {
  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(
        path ? `${location.origin}${path}` : location.href,
      );
      alert('コピーしました');
    } catch {
      alert('エラーが発生しました');
    }
  };

  return (
    <button
      className={`${String(
        className,
      )} ml-[22px] pc:hover:opacity-80 pc:hover:duration-300 pc:hover:ease-in-out`}
      onClick={async () => onClick()}
    >
      <MdShare size="20" fill="#A0A0A0" />
    </button>
  );
};
